import { render, staticRenderFns } from "./SalaryReport.vue?vue&type=template&id=3fec6196"
import script from "./SalaryReport.vue?vue&type=script&lang=js"
export * from "./SalaryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports